<template>
    <div class="password">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="原密码" prop="oldPassword">
                <el-input v-model="form.oldPassword" type="password" placeholder="请输入原密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
                <el-input v-model="form.newPassword" type="password" placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
                <el-input v-model="form.checkPass" type="password" placeholder="请确认密码"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';

export default {
    name: 'password',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.form.checkPass !== '') {
                    this.$refs.form.validateField('checkPass');
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.form.newPassword) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            form: {
                oldPassword: '',
                newPassword: '',
                checkPass: '',
            },
            rules: {
                oldPassword: [{ required: true, message: '请输入原密码', trigger: 'change' }],
                newPassword: [
                    {
                        required: true,
                        validator: validatePass,
                        message: '请输入新密码',
                        trigger: 'change',
                    },
                ],
                checkPass: [
                    {
                        required: true,
                        validator: validatePass2,
                        message: '两次输入密码不一致!',
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    methods: {
        onSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    apis.resetPassword(this.form.newPassword, this.form.oldPassword).then(res => {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                    });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
</style>